/**
 * AboutPage - sobre a MeSafa.ao
 */
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Heart, Globe2, Sparkles } from "lucide-react";
import { HERO_IMG_1 } from "@/lib/brand";

export default function AboutPage() {
    return (
        <div data-testid="about-page">
            <section className="bg-hero-radial-light">
                <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
                    <Badge variant="outline" className="mb-4 border-[#6B21D9]/30 bg-[#6B21D9]/10 text-[#6B21D9]">
                        Quem somos
                    </Badge>
                    <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight">
                        Estratégia digital ao alcance de todos.
                    </h1>
                    <p className="mt-4 max-w-2xl text-muted-foreground text-lg">
                        A MeSafa.ao nasceu em Luanda em 2025 com uma missão simples:
                        democratizar a gestão de redes sociais para PMEs em Angola e África.
                    </p>
                </div>
            </section>

            <section className="py-16">
                <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
                    <div>
                        <h2 className="font-display text-3xl font-semibold tracking-tight">
                            Feita para o nosso mercado.
                        </h2>
                        <p className="mt-3 text-muted-foreground">
                            Sabemos as suas dificuldades porque também as vivemos. As ferramentas
                            internacionais são caras, em inglês, e não entendem o nosso mercado.
                            A MeSafa fala português, aceita pagamento por Multicaixa Express e
                            está cá, em Luanda, para o ajudar.
                        </p>
                        <p className="mt-3 text-muted-foreground">
                            Acreditamos que cada empresário merece ter uma presença digital forte
                            — sem ter de contratar uma agência ou gastar 10 horas por semana.
                        </p>
                    </div>
                    <img src={HERO_IMG_1} alt="" className="rounded-3xl w-full shadow-xl" />
                </div>
            </section>

            <section className="py-16 bg-muted/30">
                <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
                    <h2 className="font-display text-3xl font-semibold tracking-tight mb-8 text-center">
                        Os nossos valores
                    </h2>
                    <div className="grid md:grid-cols-3 gap-5">
                        {[
                            {
                                icon: Heart,
                                title: "Próximos do cliente",
                                desc: "Atendimento humano em PT-PT. Falamos consigo, não com bots.",
                            },
                            {
                                icon: Globe2,
                                title: "Made in África",
                                desc: "Pensado para Angola e expandido para Moçambique, Cabo Verde e mais.",
                            },
                            {
                                icon: Sparkles,
                                title: "Tecnologia sem complicação",
                                desc: "IA poderosa, mas simples de usar. Sem manuais, sem complicações.",
                            },
                        ].map((v) => {
                            const Icon = v.icon;
                            return (
                                <Card key={v.title} className="p-6 rounded-2xl bg-card border-border">
                                    <div className="h-10 w-10 rounded-xl bg-[#6B21D9]/10 grid place-items-center text-[#6B21D9] mb-3">
                                        <Icon className="h-5 w-5" />
                                    </div>
                                    <h3 className="font-semibold text-lg">{v.title}</h3>
                                    <p className="mt-1 text-sm text-muted-foreground">{v.desc}</p>
                                </Card>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}
